import { ref } from 'vue'

/**
 * Shared open-state for the plan-upsell bottom sheet, settable from
 * non-component code (e.g. block-module `onGatedAdd` hooks). A single
 * `UpsellSheet` host bound to this ref must be mounted on the surface that
 * triggers it.
 */
export const isUpsellSheetOpen = ref(false)

/** Opens the plan-upsell sheet hosted on the current surface. */
export const openUpsellSheet = (): void => {
  isUpsellSheetOpen.value = true
}
